export default {
  tipos_concedentes: [],
  tipo_concedente: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
